import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Crown } from "lucide-react";
import { Header } from "@/components/Header";
import { useLang } from "@/context/LangContext";
import { fetchLeaderboard } from "@/lib/api";
import { termLength } from "@/lib/engine";

export default function Leaderboard() {
  const { t } = useLang();
  const navigate = useNavigate();
  const [rows, setRows] = useState(null);
  useEffect(() => { fetchLeaderboard().then(setRows).catch(() => setRows([])); }, []);

  return (
    <div className="max-w-md mx-auto min-h-dvh px-5 pb-6 flex flex-col" data-testid="leaderboard-screen">
      <Header />
      <div className="rise py-4">
        <div className="text-[11px] font-mono uppercase tracking-[0.3em] text-[var(--gold)]">🇰🇬</div>
        <h1 className="font-display font-black text-4xl tracking-tight">{t.leaderboard}</h1>
      </div>
      <div className="flex-1 flex flex-col gap-2">
        {rows === null && <div className="text-[var(--text-light)]/60">{t.loading}</div>}
        {rows?.length === 0 && <div className="panel p-6 text-center text-[var(--text-light)]/70" data-testid="leaderboard-empty">{t.empty}</div>}
        {rows?.map((r, i) => {
          const { years, months } = termLength(r.turns);
          return (
            <div key={r.id} className={`rise panel flex items-center gap-3 px-4 py-3 ${i === 0 ? "border-[var(--gold)]" : ""}`} style={{ animationDelay: `${i * 0.04}s` }} data-testid={`leaderboard-row-${i}`}>
              <div className="w-8 font-display font-black text-lg text-[var(--gold)]">{i === 0 ? <Crown size={20} /> : i + 1}</div>
              {r.picture && <img src={r.picture} alt="" referrerPolicy="no-referrer" className="w-8 h-8 rounded-full object-cover" data-testid={`leaderboard-avatar-${i}`} />}
              <div className="flex-1 min-w-0">
                <div className="font-bold truncate" data-testid={`leaderboard-nick-${i}`}>{r.nickname}</div>
                <div className="text-xs text-[var(--text-light)]/60 truncate">{t.titles[r.title_key] || r.title_key} · {years} {t.years} {months} {t.months}</div>
              </div>
              <div className="font-display font-black text-xl" data-testid={`leaderboard-score-${i}`}>{r.score}</div>
            </div>
          );
        })}
      </div>
      <button onClick={() => navigate("/intro")} className="btn-gold w-full py-4 mt-6" data-testid="leaderboard-play-btn">{t.become}</button>
    </div>
  );
}
